import { render, staticRenderFns } from "./ModalSectionCategoriesContent.vue?vue&type=template&id=9a37a856"
import script from "./ModalSectionCategoriesContent.vue?vue&type=script&lang=js"
export * from "./ModalSectionCategoriesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports